/* eslint-disable @nx/enforce-module-boundaries */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Structure } from '@job-v2/ats-utils';
import { environment } from 'apps/job-ats/src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StructuresService {
  private baseApiUrl = `${environment.apiUrl}/recruitment/structures`;
  private http = inject(HttpClient);

  getCompanyStructures(companyId: string): Observable<Structure[]> {
    return this.http.get<Structure[]>(`${this.baseApiUrl}/${companyId}`);
  }
}
